const links = {
    signup: 'https://cloud.tiledb.com/auth/signup'
}

export default links;